module.exports = __webpack_public_path__ + "static/media/miku-theme.f01e1e68.wav";